import { render, staticRenderFns } from "./RefreshDialog.vue?vue&type=template&id=256f5119&"
import script from "./RefreshDialog.vue?vue&type=script&lang=ts&"
export * from "./RefreshDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports